// Configurazione promozione corso "INVECE DI 179 PER DUE MESI A 99 EURO"
// Modifica qui per aggiornare la promo ovunque nel sito.
const TWO_MONTHS_MS = 60 * 24 * 60 * 60 * 1000;

// URL pagamento PayPal per la Tessera A.C.D.T. (€ 50) — uniforme in tutto il sito
export const PAYPAL_TESSERA_URL = "/#pacchetti";

export const PROMO = {
  active: true,
  startDate: "2026-06-21",
  endDate: new Date(Date.parse("2026-06-21") + TWO_MONTHS_MS).toISOString().slice(0, 10),
  // Prezzi corso
  prezzoListinoCorso: 179,
  prezzoPromoCorso: 99,
  scontoEuro: 80,
  // Etichette
  badge: "PROMO 2 MESI",
  labelOfferta: "Offerta limitata 2 mesi",
  labelSconto: "Risparmi 80 €",
  motivo: "Lancio · Solo per i primi iscritti",
};

// Helper per calcolare prezzi pacchetti scontati vs listino
export function prezzoListinoPacchetto(prezzoPromoFinale) {
  return prezzoPromoFinale + PROMO.scontoEuro;
}

export function formatPriceIT(v) {
  return new Intl.NumberFormat("it-IT", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
  }).format(v);
}
